module.exports = __webpack_public_path__ + "static/media/email.7c579452.png";